import(/* webpackMode: "eager" */ "/vercel/path0/src/app/artists/page.tsx");
